<template>
  <div class="mb-48">
    <HeaderBar :title="hTitle" />
    <div class="py-4 text-md border-b border-gray-300">
      Once you own a property, you will be obligated to pay Real Property Tax
      (RPT) which will be payable to the Local Government Unit, the Assessor’s
      Office.
    </div>
    <div class="py-4 text-md border-b border-gray-300">
      Updating payments for the Real Property Tax will be the responsibility of
      the buyer upon full down payment of the account.
    </div>
    <div class="py-4 text-md border-b border-gray-300">
      If you make any direct payments for your Real Property Tax at the
      Assessor’s Office, kindly submit a copy of your Official Receipt in My
      Documents so this may be deducted from what will be collected from you.
    </div>
    <div class="py-4 text-md border-b border-gray-300">
      Home Page --> My Documents --> Submit Documents
    </div>
    <div class="py-4 text-md border-b border-gray-300">
      Ensure to pay your Real Property Tax on time to avoid incurring penalties.
    </div>
  </div>
</template>
<script>
import HeaderBar from "../../components/HeaderBar.vue";
export default {
  props: ["hTitle"],
  components: { HeaderBar },
};
</script>